import { Button } from "@/components/ui/button"
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog"

type Props = {
	isModalOpen: boolean
	setIsModalOpen: (value: boolean) => void
	title: string
	messages: string[]
	confirmTitle: React.ReactNode
	confirmAction: () => void
	isDisabled: boolean
}

const ConfirmPopUpModal = ({
	isModalOpen,
	setIsModalOpen,
	title,
	messages,
	confirmTitle,
	confirmAction,
	isDisabled,
}: Props) => {
	return (
		<Dialog
			open={isModalOpen}
			onOpenChange={setIsModalOpen}
		>
			<DialogContent
				className="max-w-sm rounded-lg"
				style={{ maxWidth: "400px" }}
			>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
				</DialogHeader>
				<DialogDescription className="space-y-2">
					{messages.map((message, index) => (
						<p
							key={index}
							className="text-sm"
						>
							{message}
						</p>
					))}
				</DialogDescription>
				<DialogFooter className="flex items-center justify-center gap-2">
					<DialogClose asChild>
						<Button
							variant="outline"
							className="rounded-full"
						>
							Cancel
						</Button>
					</DialogClose>
					<Button
						disabled={isDisabled}
						onClick={confirmAction}
						className="rounded-full"
					>
						{confirmTitle}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}

export default ConfirmPopUpModal
